import {
  Code2,
  FileSpreadsheet,
  FileText,
  MousePointerClick,
  Type,
} from 'lucide-react';

// Mirrors the `theme` keys in workspaceVariants.js so the Script stage reads
// as the same product identity as the surrounding workspace sidebar. Excel is
// the one deliberate exception: its app-wide brand color is emerald, which
// would collide with this screen's semantic green (ready/passed/success), so
// it gets indigo here instead. Every other key matches its workspace color.
export const SCRIPT_STAGE_THEMES = {
  brd: {
    key: 'brd',
    Icon: FileText,
    iconBadge: 'bg-blue-50 text-blue-700',
    chip: 'border-blue-100 bg-blue-50 text-blue-700',
    primaryButton: 'bg-blue-700 hover:bg-blue-800 text-white',
    secondaryHover: 'hover:border-blue-300 hover:bg-blue-50',
    cardAccentBorder: 'border-l-blue-500',
    selectedBorder: 'border-l-blue-500',
    selectedTint: 'bg-blue-50/60',
    accentText: 'text-blue-700',
    accentControl: 'accent-blue-700',
    onDark: 'text-blue-200',
  },
  requirements: {
    key: 'requirements',
    Icon: Type,
    iconBadge: 'bg-violet-50 text-violet-700',
    chip: 'border-violet-100 bg-violet-50 text-violet-700',
    primaryButton: 'bg-violet-700 hover:bg-violet-800 text-white',
    secondaryHover: 'hover:border-violet-300 hover:bg-violet-50',
    cardAccentBorder: 'border-l-violet-500',
    selectedBorder: 'border-l-violet-500',
    selectedTint: 'bg-violet-50/60',
    accentText: 'text-violet-700',
    accentControl: 'accent-violet-700',
    onDark: 'text-violet-200',
  },
  api: {
    key: 'api',
    Icon: Code2,
    iconBadge: 'bg-sky-50 text-sky-700',
    chip: 'border-sky-100 bg-sky-50 text-sky-700',
    primaryButton: 'bg-sky-700 hover:bg-sky-800 text-white',
    secondaryHover: 'hover:border-sky-300 hover:bg-sky-50',
    cardAccentBorder: 'border-l-sky-500',
    selectedBorder: 'border-l-sky-500',
    selectedTint: 'bg-sky-50/60',
    accentText: 'text-sky-700',
    accentControl: 'accent-sky-700',
    onDark: 'text-sky-200',
  },
  excel: {
    key: 'excel',
    Icon: FileSpreadsheet,
    iconBadge: 'bg-indigo-50 text-indigo-700',
    chip: 'border-indigo-100 bg-indigo-50 text-indigo-700',
    primaryButton: 'bg-indigo-700 hover:bg-indigo-800 text-white',
    secondaryHover: 'hover:border-indigo-300 hover:bg-indigo-50',
    cardAccentBorder: 'border-l-indigo-500',
    selectedBorder: 'border-l-indigo-500',
    selectedTint: 'bg-indigo-50/60',
    accentText: 'text-indigo-700',
    accentControl: 'accent-indigo-700',
    onDark: 'text-indigo-200',
  },
  capture: {
    key: 'capture',
    Icon: MousePointerClick,
    iconBadge: 'bg-teal-50 text-teal-700',
    chip: 'border-teal-100 bg-teal-50 text-teal-700',
    primaryButton: 'bg-teal-700 hover:bg-teal-800 text-white',
    secondaryHover: 'hover:border-teal-300 hover:bg-teal-50',
    cardAccentBorder: 'border-l-teal-500',
    selectedBorder: 'border-l-teal-500',
    selectedTint: 'bg-teal-50/60',
    accentText: 'text-teal-700',
    accentControl: 'accent-teal-700',
    onDark: 'text-teal-200',
  },
};

export function getScriptStageTheme(themeKey) {
  return SCRIPT_STAGE_THEMES[themeKey] || SCRIPT_STAGE_THEMES.brd;
}
